import React from "react";
import { Form, Input, Button, message } from "antd";
import axiosInstance from "../api/axiosIntance";

const LoginForm = ({ switchToSignup }) => {
  const handleFinish = async (values) => {
    try {
      // Log the form values
      console.log("Login Form Values:", values);

      // Make API call to login
      const response = await axiosInstance.post("/api/auth/login", values);
      console.log(response)
      // Handle success
      message.success("Login successful!");
      console.log("Response from server:", response.data);
      

      // Optionally handle token storage or user navigation
      // localStorage.setItem("token", response.data.token);
      // navigate("/dashboard");
    } catch (error) {
      // Handle errors based on status codes
      console.log(error)
      if (error.response) {
        const statusCode = error.response.status;
        switch (statusCode) {
          case 400:
            message.error(error.response.data.error || "Bad Request");
            break;
          case 401:
            message.error("Unauthorized: Invalid email or password.");
            break;
          case 500:
            message.error("Server Error: Please try again later.");
            break;
          default:
            message.error(
              error.response.data?.message || "An unexpected error occurred."
            );
        }
      } else {
        // Network error or no response
        message.error("Network error: Please check your connection.");
      }
    }
  };

  return (
    <Form layout="vertical" onFinish={handleFinish}>
      <h2>Login</h2>

      <Form.Item
        name="email"
        label="Email Address"
        rules={[
          { required: true, type: "email", message: "Valid email is required" },
        ]}
      >
        <Input placeholder="Email Address" />
      </Form.Item>

      <Form.Item
        name="password"
        label="Password"
        rules={[{ required: true, message: "Password is required" }]}
      >
        <Input.Password placeholder="Password" />
      </Form.Item>

      <Button type="primary" htmlType="submit" style={{ marginTop: "10px" }}>
        Login
      </Button>

      <p style={{ marginTop: "10px" }}>
        Don't have an account?{" "}
        <Button type="link" onClick={switchToSignup}>
          Sign Up
        </Button>
      </p>
    </Form>
  );
};

export default LoginForm;
